import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment } from '@mui/material';
// component
import Iconify from '../../../components/iconify';
import { DeleteUsers } from '../../../components/services/httpServices';
import { useContext } from 'react';
import { AuthContext } from 'src/components/Context/Auth/auth.context';
import ModalLayout from 'src/theme/Modal';
import { Trash } from 'react-feather/dist';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

RecrutmentListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};
// const deleteUsers = (selectedUsersList) => {
//   DeleteUsers
// };

export default function RecrutmentListToolbar({ numSelected, filterName, onFilterName, selectedUsers, deleteUsers }) {
  let {
    authState: { userRole },
  } = useContext(AuthContext);
  // console.log('SELECTED USERS:', numSelected);
  //  console.log('SELECTED USERS:', selectedUsers);
  //  console.log('userRole:', userRole);
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      {
        numSelected > 0 ? (
          <ModalLayout component={<Trash />} description="Are You Sure you want to Delete?" Hit={deleteUsers} />
        ) : null
        /* <Tooltip title="Filter list">
          <IconButton>
            <Iconify icon="ic:round-filter-list" />
          </IconButton>
        </Tooltip> */
      }
    </StyledRoot>
  );
}
